import { motion } from 'framer-motion';
import { AlertTriangle, XCircle } from 'lucide-react';
import { AnimatedSection, AnimatedItem, AnimatedCard, staggerContainer } from '@/components/animations';

const problems = [
  'Sob pressão',
  'Com informação assimétrica',
  'Com conflito de interesses',
  'Sem base técnica independente',
];

export function ProblemSection() {
  return (
    <section className="py-20 md:py-28 border-t border-border">
      <div className="container">
        <AnimatedSection className="max-w-4xl mx-auto" stagger>
          <AnimatedItem className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-destructive/10 text-destructive text-sm font-medium mb-6">
              <AlertTriangle className="w-4 h-4" />
              O Problema
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              O maior risco não é o elevador.
              <br />
              <span className="text-destructive">É a decisão.</span>
            </h2>
          </AnimatedItem>

          <AnimatedItem>
            <p className="text-lg text-muted-foreground text-center mb-10">
              Em situações críticas — modernizações, substituições ou
              recomendações técnicas — as decisões são frequentemente tomadas:
            </p>
          </AnimatedItem>

          <motion.div
            className="grid sm:grid-cols-2 gap-4 mb-8"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-50px' }}
          >
            {problems.map((item, idx) => (
              <AnimatedCard
                key={idx}
                className="flex items-center gap-3 p-4 rounded-xl bg-destructive/5 border border-destructive/20"
              >
                <XCircle className="w-5 h-5 text-destructive shrink-0" />
                <span className="text-foreground font-medium">{item}</span>
              </AnimatedCard>
            ))}
          </motion.div>

          <AnimatedItem className="text-center p-6 rounded-2xl bg-destructive/5 border border-destructive/20">
            <p className="text-lg font-semibold text-foreground">
              O custo de decidir mal é técnico, financeiro e jurídico.
            </p>
          </AnimatedItem>
        </AnimatedSection>
      </div>
    </section>
  );
}
